import { j as s } from "../../jsx-runtime.BREq8dyb.js";
import { cx as P } from "@emotion/css";
import { styled as y, Drawer as D, drawerClasses as p, useThemeProps as k, ModalDialog as q } from "@mui/joy";
import { memo as r, useMemo as S, Children as x, cloneElement as g, isValidElement as w, useRef as j } from "react";
import { i as C } from "../../react-click-away-listener.BrTEM9EK.js";
const m = {
  inset: "DqSidePanel-inset"
}, u = "DqSidePanel", E = y(D, {
  name: u,
  slot: "root"
})(({
  theme: n
}) => ({
  hideBackdrop: e
}) => ({
  pointerEvents: e ? "none" : "auto",
  [`& > .${p.content}`]: {
    pointerEvents: "auto"
  },
  [`&.${m.inset} > .${p.content}`]: {
    backgroundColor: "transparent",
    boxShadow: "none",
    [n.breakpoints.up("md")]: {
      padding: n.spacing(2)
    }
  }
})), l = r((n) => {
  const {
    children: e,
    className: a,
    inset: t = !1,
    onClickAway: i,
    variant: o,
    ...A
  } = k({
    name: u,
    props: n
  }), d = S(() => /* @__PURE__ */ s.jsx(c, { children: /* @__PURE__ */ s.jsx(q, { variant: t ? o : "plain", children: e }) }), [e, t, o]);
  return /* @__PURE__ */ s.jsx(E, { className: P(a, {
    [m.inset]: t
  }), variant: t ? "plain" : o, ...A, children: typeof i == "function" ? /* @__PURE__ */ s.jsx(C, { onClickAway: i, children: d }) : d });
});
l.displayName = "DqSidePanel";
const f = "data-dq-side-panel-click-away-absorber", c = r(({
  children: n
}) => {
  const e = {
    [f]: !0
  };
  return x.map(n, (a) => w(a) ? g(a, e) : /* @__PURE__ */ s.jsx("span", { ...e, children: a }));
});
c.displayName = "DqSidePanelClickAwayAbsorber";
const b = r(({
  open: n,
  onClose: e,
  ...a
}) => {
  const t = j(null);
  return /* @__PURE__ */ s.jsx(l, { onClose: e, open: n, ref: t, ...a, disableEnforceFocus: !0, hideBackdrop: !0, onClickAway: (i) => {
    n && typeof e == "function" && t.current instanceof HTMLDivElement && !t.current.hasAttribute("aria-hidden") && i instanceof PointerEvent && i.target instanceof HTMLElement && i.target.closest(`[${f}]`) === null && e(i, "backdropClick");
  } });
});
b.displayName = "DqSidePanelFloating";
const M = Object.assign(l, {
  ClickAwayAbsorber: c,
  Floating: b
});
export {
  M as default,
  m as dqSidePanelClasses
};
//# sourceMappingURL=DqSidePanel.js.map
